<template>
  <div>
    <div class="page-head">
      <div>
        <h2>支付方式</h2>
        <p>维护收款、收入、支出与发放可选的支付方式</p>
      </div>
      <el-button
        type="primary"
        @click="dialog = true"
      >
        新增方式
      </el-button>
    </div>
    <el-card shadow="never">
      <el-table
        :data="rows"
        v-loading="loading"
      >
        <el-table-column
          prop="code"
          label="编码"
        />
        <el-table-column
          prop="name"
          label="名称"
        />
        <el-table-column
          prop="sort"
          label="排序"
        />
        <el-table-column label="状态">
          <template #default="{ row }">
            <el-tag :type="row.enabled ? 'success' : 'info'">
              {{ row.enabled ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template #default="{ row }">
            <el-button
              v-if="row.id"
              link
              :type="row.enabled ? 'danger' : 'success'"
              @click="toggle(row)"
            >
              {{ row.enabled ? '停用' : '启用' }}
            </el-button>
            <span v-else>系统默认</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      v-model="dialog"
      title="新增支付方式"
      width="450px"
    >
      <el-form label-width="80px">
        <el-form-item
          label="编码"
          required
        >
          <el-input v-model="form.code" />
        </el-form-item>
        <el-form-item
          label="名称"
          required
        >
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number
            v-model="form.sort"
            :min="0"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialog = false">取消</el-button>
        <el-button
          type="primary"
          :loading="saving"
          @click="save"
        >
          保存
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { onMounted, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { organizationApi } from '../api'
const rows = ref([]),
  loading = ref(false),
  dialog = ref(false),
  saving = ref(false),
  form = reactive({ code: '', name: '', sort: 0 })
const load = async () => {
  loading.value = true
  try {
    rows.value = (await organizationApi.paymentMethods()) || []
  } finally {
    loading.value = false
  }
}
const save = async () => {
  if (!form.code || !form.name) return ElMessage.warning('请填写编码和名称')
  saving.value = true
  try {
    await organizationApi.createPaymentMethod(form)
    dialog.value = false
    Object.assign(form, { code: '', name: '', sort: 0 })
    load()
  } catch (e) {
    ElMessage.error(e?.message || '保存失败')
  } finally {
    saving.value = false
  }
}
const toggle = async (r) => {
  try {
    await organizationApi.togglePaymentMethod(r.id, !r.enabled)
    load()
  } catch (e) {
    ElMessage.error(e?.message || '操作失败')
  }
}
onMounted(load)
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
}
.page-head p {
  color: #8492a6;
  margin-top: 6px;
}
.el-card {
  border: 0;
}
</style>
